import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
  dividelr0uqtdj497z as divide,
} from '../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Buffer3384y49aj0pxr as Buffer } from './Buffer.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toMutableList3ewlpx8m5ca2q as toMutableList } from '../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { sort15ai02l4kxbfa as sort } from '../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { binarySearch1nmlzx9onl5pm as binarySearch } from '../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { AbstractList3ck35puwbp1e9 as AbstractList } from '../../kotlin-kotlin-stdlib/kotlin/collections/AbstractList.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from '../../kotlin-kotlin-stdlib/kotlin/collections/RandomAccess.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function buildTrieRecursive($this, nodeOffset, node, byteStringOffset, byteStrings, fromIndex, toIndex, indexes) {
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(fromIndex < toIndex)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException().s2(toString(message));
  }
  var inductionVariable = fromIndex;
  if (inductionVariable < toIndex)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!(byteStrings.w2(i).v2() >= byteStringOffset)) {
        var message_0 = 'Failed requirement.';
        throw IllegalArgumentException().s2(toString(message_0));
      }
    }
     while (inductionVariable < toIndex);
  var fromIndex_0 = fromIndex;
  var from = byteStrings.w2(fromIndex_0);
  var to = byteStrings.w2(toIndex - 1 | 0);
  var prefixIndex = -1;
  if (byteStringOffset === from.v2()) {
    prefixIndex = indexes.w2(fromIndex_0);
    fromIndex_0 = fromIndex_0 + 1 | 0;
    from = byteStrings.w2(fromIndex_0);
  }
  if (!(from.w2(byteStringOffset) === to.w2(byteStringOffset))) {
    var selectChoiceCount = 1;
    var inductionVariable_0 = fromIndex_0 + 1 | 0;
    if (inductionVariable_0 < toIndex)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (!(byteStrings.w2(i_0 - 1 | 0).w2(byteStringOffset) === byteStrings.w2(i_0).w2(byteStringOffset))) {
          selectChoiceCount = selectChoiceCount + 1 | 0;
        }
      }
       while (inductionVariable_0 < toIndex);
    // Inline function 'kotlin.Long.plus' call
    var this_0 = add(nodeOffset, _get_intCount__gol563($this, node));
    var tmp0 = add(this_0, fromInt(2));
    // Inline function 'kotlin.Long.plus' call
    var other = imul(selectChoiceCount, 2);
    var childNodesOffset = add(tmp0, fromInt(other));
    node.p3v(selectChoiceCount);
    node.p3v(prefixIndex);
    var inductionVariable_1 = fromIndex_0;
    if (inductionVariable_1 < toIndex)
      do {
        var i_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var rangeByte = byteStrings.w2(i_1).w2(byteStringOffset);
        if (i_1 === fromIndex_0 || !(rangeByte === byteStrings.w2(i_1 - 1 | 0).w2(byteStringOffset))) {
          // Inline function 'okio.and' call
          var tmp$ret$8 = rangeByte & 255;
          node.p3v(tmp$ret$8);
        }
      }
       while (inductionVariable_1 < toIndex);
    var childNodes = new (Buffer())();
    var rangeStart = fromIndex_0;
    while (rangeStart < toIndex) {
      var rangeByte_0 = byteStrings.w2(rangeStart).w2(byteStringOffset);
      var rangeEnd = toIndex;
      var inductionVariable_2 = rangeStart + 1 | 0;
      if (inductionVariable_2 < toIndex)
        $l$loop: do {
          var i_2 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          if (!(rangeByte_0 === byteStrings.w2(i_2).w2(byteStringOffset))) {
            rangeEnd = i_2;
            break $l$loop;
          }
        }
         while (inductionVariable_2 < toIndex);
      if ((rangeStart + 1 | 0) === rangeEnd && (byteStringOffset + 1 | 0) === byteStrings.w2(rangeStart).v2()) {
        node.p3v(indexes.w2(rangeStart));
      } else {
        node.p3v(imul(-1, convertToInt(add(childNodesOffset, _get_intCount__gol563($this, childNodes)))));
        buildTrieRecursive($this, childNodesOffset, childNodes, byteStringOffset + 1 | 0, byteStrings, rangeStart, rangeEnd, indexes);
      }
      rangeStart = rangeEnd;
    }
    node.q3v(childNodes);
  } else {
    var scanByteCount = 0;
    var inductionVariable_3 = byteStringOffset;
    var tmp0_0 = from.v2();
    // Inline function 'kotlin.comparisons.minOf' call
    var b = to.v2();
    var last = Math.min(tmp0_0, b);
    if (inductionVariable_3 < last)
      $l$loop_0: do {
        var i_3 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        if (from.w2(i_3) === to.w2(i_3)) {
          scanByteCount = scanByteCount + 1 | 0;
        } else {
          break $l$loop_0;
        }
      }
       while (inductionVariable_3 < last);
    // Inline function 'kotlin.Long.plus' call
    var this_1 = add(nodeOffset, _get_intCount__gol563($this, node));
    var tmp0_1 = add(this_1, fromInt(2));
    // Inline function 'kotlin.Long.plus' call
    var other_0 = scanByteCount;
    // Inline function 'kotlin.Long.plus' call
    var this_2 = add(tmp0_1, fromInt(other_0));
    var childNodesOffset_0 = add(this_2, fromInt(1));
    node.p3v(-scanByteCount | 0);
    node.p3v(prefixIndex);
    var inductionVariable_4 = byteStringOffset;
    var last_0 = byteStringOffset + scanByteCount | 0;
    if (inductionVariable_4 < last_0)
      do {
        var i_4 = inductionVariable_4;
        inductionVariable_4 = inductionVariable_4 + 1 | 0;
        // Inline function 'okio.and' call
        var tmp$ret$13 = from.w2(i_4) & 255;
        node.p3v(tmp$ret$13);
      }
       while (inductionVariable_4 < last_0);
    if ((fromIndex_0 + 1 | 0) === toIndex) {
      // Inline function 'kotlin.check' call
      if (!((byteStringOffset + scanByteCount | 0) === byteStrings.w2(fromIndex_0).v2())) {
        throw IllegalStateException().o('Check failed.');
      }
      node.p3v(indexes.w2(fromIndex_0));
    } else {
      var childNodes_0 = new (Buffer())();
      node.p3v(imul(-1, convertToInt(add(childNodesOffset_0, _get_intCount__gol563($this, childNodes_0)))));
      buildTrieRecursive($this, childNodesOffset_0, childNodes_0, byteStringOffset + scanByteCount | 0, byteStrings, fromIndex_0, toIndex, indexes);
      node.q3v(childNodes_0);
    }
  }
}
function buildTrieRecursive$default($this, nodeOffset, node, byteStringOffset, byteStrings, fromIndex, toIndex, indexes, $super) {
  nodeOffset = nodeOffset === VOID ? 0n : nodeOffset;
  byteStringOffset = byteStringOffset === VOID ? 0 : byteStringOffset;
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? byteStrings.v2() : toIndex;
  return buildTrieRecursive($this, nodeOffset, node, byteStringOffset, byteStrings, fromIndex, toIndex, indexes);
}
function _get_intCount__gol563($this, _this__u8e3s4) {
  // Inline function 'kotlin.Long.div' call
  var this_0 = _this__u8e3s4.k3v_1;
  return divide(this_0, fromInt(4));
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      r3v(byteStrings) {
        // Inline function 'kotlin.collections.isEmpty' call
        if (byteStrings.length === 0) {
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = [];
          // Inline function 'kotlin.intArrayOf' call
          var tmp$ret$4 = new Int32Array([0, -1]);
          return Options().u3v(tmp, tmp$ret$4);
        }
        var list = toMutableList(byteStrings);
        sort(list);
        // Inline function 'kotlin.collections.MutableList' call
        var size = list.v2();
        var list_0 = ArrayList().m2(size);
        // Inline function 'kotlin.repeat' call
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            list_0.n2(-1);
          }
           while (inductionVariable < size);
        var indexes = list_0;
        // Inline function 'kotlin.collections.forEachIndexed' call
        var index_0 = 0;
        var inductionVariable_0 = 0;
        var last = byteStrings.length;
        while (inductionVariable_0 < last) {
          var item = byteStrings[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var _unary__edvuaz = index_0;
          index_0 = _unary__edvuaz + 1 | 0;
          var sortedIndex = binarySearch(list, item);
          indexes.o3(sortedIndex, _unary__edvuaz);
        }
        // Inline function 'kotlin.require' call
        if (!(list.w2(0).v2() > 0)) {
          var message = 'the empty byte string is not a supported option';
          throw IllegalArgumentException().s2(toString(message));
        }
        var a = 0;
        while (a < list.v2()) {
          var prefix = list.w2(a);
          var b = a + 1 | 0;
          $l$loop: while (b < list.v2()) {
            var byteString = list.w2(b);
            if (!byteString.v3v(prefix))
              break $l$loop;
            // Inline function 'kotlin.require' call
            if (!!(byteString.v2() === prefix.v2())) {
              var message_0 = 'duplicate option: ' + byteString.toString();
              throw IllegalArgumentException().s2(toString(message_0));
            }
            if (indexes.w2(b) > indexes.w2(a)) {
              list.h5(b);
              indexes.h5(b);
            } else {
              b = b + 1 | 0;
            }
          }
          a = a + 1 | 0;
        }
        var trieBytes = new (Buffer())();
        buildTrieRecursive$default(this, VOID, trieBytes, VOID, list, VOID, VOID, indexes);
        var tmp_0 = 0;
        var tmp_1 = convertToInt(_get_intCount__gol563(this, trieBytes));
        var tmp_2 = new Int32Array(tmp_1);
        while (tmp_0 < tmp_1) {
          tmp_2[tmp_0] = trieBytes.w3v();
          tmp_0 = tmp_0 + 1 | 0;
        }
        var trie = tmp_2;
        // Inline function 'kotlin.collections.copyOf' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$17 = byteStrings.slice();
        return Options().u3v(tmp$ret$17, trie);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var OptionsClass;
function Options() {
  if (OptionsClass === VOID) {
    class $ extends AbstractList() {
      static u3v(byteStrings, trie) {
        var $this = this.bj();
        $this.s3v_1 = byteStrings;
        $this.t3v_1 = trie;
        return $this;
      }
      v2() {
        return this.s3v_1.length;
      }
      w2(index) {
        return this.s3v_1[index];
      }
    }
    initMetadataForClass($, 'Options', VOID, VOID, [AbstractList(), RandomAccess()]);
    OptionsClass = $;
  }
  return OptionsClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance35rvxj4aba79n,
};
//endregion

//# sourceMappingURL=Options.mjs.map
